import { render, staticRenderFns } from "./project-template-list.vue?vue&type=template&id=a05d8824&scoped=true&"
import script from "./project-template-list.vue?vue&type=script&lang=js&"
export * from "./project-template-list.vue?vue&type=script&lang=js&"
import style0 from "./project-template-list.vue?vue&type=style&index=0&id=a05d8824&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a05d8824",
  null
  
)

/* custom blocks */
import block0 from "./project-template-list.vue?vue&type=custom&index=0&blockType=fragments"
if (typeof block0 === 'function') block0(component)

export default component.exports